module.exports = __webpack_public_path__ + "4eff08c3fdd225f35f0b4f87cb1825c6.jpg";